import actions from './actions';
import { translationsRootKey } from '../../../settings/index';
import { createReducer } from '../../../helpers/reducer';
import {
  initInputField,
  getInitialDayFormData,
  initAddressData,
  validate,
  validate12and15hoursDurations,
  getDefaultStartTime,
  recurrenceType,
} from '../helpers/helpers';
import { t } from '../../../i18n';

const initState = {
  loading: false,
  recentLocations: [],
  managers: [],
  isRecurringSelected: false,
  isExcludeWeekendsSelected: false,
  isIncludeSamePositionsSelected: false,
  frequency: recurrenceType.weekly, // once_off, daily, weekly, monthly,
  typeForm: {
    type: initInputField('type', 'orientation'),
  },
  nameForm: {
    name: initInputField('name', t(`${translationsRootKey}.orientations.form_name`)),
  },
  addressForm: {
    address: initInputField('address', initAddressData()),
    selectedAddressType: initInputField('selectedAddressType', 'autocomplete'),
  },
  primaryConstactForm: {
    contact: initInputField('contact', ''),
  },
  bookingForm: {
    days: initInputField('days', [
      { date: null, bookings: [getInitialDayFormData({ startsAt: getDefaultStartTime() })] },
    ]),
  },
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state) {
  return {
    ...state,
    loading: false,
  };
}

function onChangeFrequency(state, { payload }) {
  return {
    ...state,
    frequency: payload,
  };
}

function onToggleRecurringSelected(state, { payload }) {
  return {
    ...state,
    isRecurringSelected: payload,
  };
}

function onToggleExcludeWeekendsSelected(state, { payload }) {
  return {
    ...state,
    isExcludeWeekendsSelected: payload,
  };
}

function onToggleIncludeSamePositionsSelected(state, { payload }) {
  return {
    ...state,
    isIncludeSamePositionsSelected: payload,
  };
}

function onChangeProperty(state, { payload }) {
  const { formName, attr, value, params = {} } = payload;
  const { fields = [] } = params;

  if (attr === 'days' && params) {
    const days = value;
    days.forEach(day => {
      day.bookings.forEach(booking => {
        if (params.attr === 'starts_at' || params.attr === 'finishes_at') {
          validate12and15hoursDurations(booking);
        }
      });
    });

    fields.forEach(field => {
      field.error = validate(field.name, field.value, { ...params });
      field.touched = true;
    });
  }

  state[formName][attr] = {
    value,
    error: validate(attr, value, { ...params }),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    [formName]: {
      ...state[formName],
    },
  };
}

function onTouchProperty(state, { payload }) {
  const { form } = payload;

  Object.entries(form)
    .filter(([, data]) => Boolean(data))
    .forEach(([, data]) => {
      if (typeof data === 'object') {
        data.touched = true;
      }
    });

  return {
    ...state,
  };
}

function onLoadManagersSuccess(state, { payload }) {
  const { data } = payload;

  return {
    ...state,
    managers: data,
  };
}

function onLoadRecentLocationsSuccess(state, { payload }) {
  const { data } = payload;

  return {
    ...state,
    recentLocations: data,
  };
}

function onCreateOrientationRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onCreateOrientationSuccess(state) {
  return {
    ...state,
    loading: false,
  };
}

function onCreateOrientationFailed(state) {
  return {
    ...state,
    loading: false,
  };
}

function onClearStore() {
  return {
    ...initState,
    typeForm: {
      type: initInputField('type', 'orientation'),
    },
    nameForm: {
      name: initInputField('name', t(`${translationsRootKey}.orientations.form_name`)),
    },
    addressForm: {
      address: initInputField('address', initAddressData()),
      selectedAddressType: initInputField('selectedAddressType', 'autocomplete'),
    },
    primaryConstactForm: {
      contact: initInputField('contact', ''),
    },
    bookingForm: {
      days: initInputField('days', [
        { date: null, bookings: [getInitialDayFormData({ startsAt: getDefaultStartTime() })] },
      ]),
    },
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.TOUCH_PROPERTY]: onTouchProperty,
  [actions.CHANGE_FREQUENCY]: onChangeFrequency,
  [actions.TOGGLE_RECURRING_SELECTED]: onToggleRecurringSelected,
  [actions.TOGGLE_EXCLUDE_WEEKENDS_SELECTED]: onToggleExcludeWeekendsSelected,
  [actions.TOGGLE_INCLUDE_SAME_POSITION_SELECTED]: onToggleIncludeSamePositionsSelected,
  [actions.LOAD_MANAGERS_SUCCESS]: onLoadManagersSuccess,
  [actions.LOAD_RECENT_LOCATIONS_SUCCESS]: onLoadRecentLocationsSuccess,
  [actions.CREATE_ORIENTATION_REQUEST]: onCreateOrientationRequest,
  [actions.CREATE_ORIENTATION_SUCCESS]: onCreateOrientationSuccess,
  [actions.CREATE_ORIENTATION_FAILED]: onCreateOrientationFailed,
  [actions.CLEAR_STORE]: onClearStore,
});
